import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { Link } from "@quintype/components";
import "./middle-section.m.css";

const links = [
  {
    name: "UAE",
    url: "/gold-forex?utm_source=goldforex&utm_medium=price_tracker&utm_campaign=uae_gold_prices",
    slug: "gold-forex",
  },
  {
    name: "Saudi",
    url: "/gold-forex/saudi-gold-prices?utm_source=goldforex&utm_medium=price_tracker&utm_campaign=saudi_gold_prices",
    slug: "saudi-gold-prices",
  },
  {
    name: "Qatar",
    url: "/gold-forex/qatar-gold-prices?utm_source=goldforex&utm_medium=price_tracker&utm_campaign=qatar_gold_prices",
    slug: "qatar-gold-prices",
  },
  {
    name: "Oman",
    url: "/gold-forex/oman-gold-prices?utm_source=goldforex&utm_medium=price_tracker&utm_campaign=oman_gold_prices",
    slug: "oman-gold-prices",
  },
  {
    name: "Bahrain",
    url: "/gold-forex/bahrain-gold-prices?utm_source=goldforex&utm_medium=price_tracker&utm_campaign=bahrain_gold_prices",
    slug: "bahrain-gold-prices",
  },
  {
    name: "Kuwait",
    url: "/gold-forex/kuwait-gold-prices?utm_source=goldforex&utm_medium=price_tracker&utm_campaign=kuwait_gold_prices",
    slug: "kuwait-gold-prices",
  },
];

const GoldRateLinks = () => {
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));
  const cleanUrl = currentPath?.split("?")[0];
  const segments = cleanUrl?.split("/").filter(Boolean);
  const slug = segments.pop();
  return (
    <div styleName="gold-rate-links-wrapper">
      <div styleName="title">Check gold rates for more countries:</div>
      <div styleName="links-list">
        {links
          .filter((t) => slug !== t.slug)
          .map((t) => (
            <div key={t.name}>
              <Link href={t.url}>
                <span>
                  <SvgIconHandler type={`${t.name.toLowerCase()}`} width="14px" height="14px" viewBox="0 0 14 14" />
                </span>

                {t.name}
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export default GoldRateLinks;
